
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11739',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11739",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "dashboard-client-types": "static-1.278",
  "data-fetching-client": "static-1.9536",
  "foundations-components": "static-1.7635",
  "foundations-components-legacy": "static-1.660",
  "foundations-theming": "static-1.4270",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.78",
  "head-dlb": "static-1.4884",
  "hs-test-utils": "static-1.7866",
  "hub-http-shared-msw-handlers": "static-1.9620",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11302",
  "I18n": "static-7.1589",
  "jasmine-runner": "static-1.6329",
  "marketplace-storefront-base": "static-1.11799",
  "quartz": "static-1.6809",
  "react-dlb": "static-1.74",
  "react-rhumb": "static-1.16509",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2722",
  "reporting-testing-lib": "static-1.8704",
  "settings-ui-lib": "static-1.12382",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6852",
  "ui-addon-i18n": "static-1.11003",
  "ui-addon-react-router-dom": "static-1.9404",
  "unified-auth": "static-1.295",
  "unified-auth-core-lib": "static-1.576",
  "usage-tracker": "static-1.7194",
  "usage-tracker-core": "static-1.7044",
  "customer-data-property-utils": "static-1.7939",
  "history": "static-4.47",
  "hub-http": "static-1.6076",
  "integrations-lib": "static-1.15613",
  "marketplace-ui-common": "static-1.19118",
  "property-management-iframe": "static-1.12594",
  "quartz-config": "static-1.587",
  "quartz-core": "static-1.6028",
  "quartz-routing": "static-1.239",
  "quick-fetch": "static-1.3793",
  "react": "static-7.182",
  "rpc-client-utils": "static-1.4501",
  "ts-schema": "static-1.3960",
  "ui-universal-auth": "static-1.8781",
  "UIComponents": "static-3.8249",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.416",
  "hs-promise-rejection-tracking": "static-1.5433",
  "PortalIdParser": "static-2.377",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3285",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3086",
  "quartz-webpack": "static-1.3033",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3904",
  "floating-ui": "static-1.52",
  "foundations-assets": "static-1.4700",
  "foundations-theming-specialty": "static-1.1986",
  "framer-motion": "static-1.68",
  "hs-story-utils": "static-1.9285",
  "react-aria": "static-1.62",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5230",
  "react-virtualized": "static-2.95",
  "StyleGuideUI": "static-3.485",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1369",
  "ui-fonts": "static-1.564",
  "ui-images": "static-2.1114",
  "bend-plugin-foundations-theming": "static-1.2753",
  "foundations-theming-base": "static-1.3255",
  "stylex": "static-1.28",
  "HeadJS": "static-2.724",
  "hs-test-utils-bend-plugin": "static-1.2977",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4185",
  "ai-components-ui-library": "static-1.8529",
  "ai-rendering-library": "static-1.9491",
  "chirp-fetch": "static-1.1742",
  "connections-embed-lib": "static-1.719",
  "copilot-toolkit": "static-1.10687",
  "laboratory-lib": "static-3.7018",
  "marketplace-embed": "static-1.21632",
  "marketplace-ui-details": "static-1.9014",
  "marketplace-ui-reviews": "static-1.19074",
  "marketplace-ui-tracking": "static-1.13289",
  "sanitize-text": "static-1.8004",
  "ui-addon-video-player": "static-1.8555",
  "usage-tracker-multi": "static-1.5608",
  "usage-tracker-session-replay": "static-1.4880",
  "wootric-nps": "static-1.6841",
  "apollo-link-hub-http": "static-2.4510",
  "immer": "static-1.33",
  "immerable": "static-1.4013",
  "highcharts": "static-8.100",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2403",
  "reporting-data": "static-1.66771",
  "cssUtils": "static-1.754",
  "flux-actions": "static-1.317",
  "HubStyle": "static-2.11610",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10070",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10233",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7184",
  "icons": "static-2.631",
  "marketplace-ui-apps-core": "static-1.17651",
  "storybook-react": "static-1.29",
  "trellis-story-utils": "static-1.4379",
  "foundations-components-test-utils": "static-1.5118",
  "quartz-i18n": "static-1.484",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3589",
  "customer-data-objects": "static-1.7511",
  "property-translator": "static-1.5269",
  "frontend-preferences-client": "static-1.7783",
  "hs-promise-utils": "static-1.5452",
  "hubspot-apollo-client": "static-1.4738",
  "integrations-error-boundary-lib": "static-1.13028",
  "integrations-tracking-lib": "static-1.5449",
  "native-integrations-shared-strings": "static-1.7646",
  "reselect": "static-2.16",
  "sanitize": "static-1.4333",
  "superstore": "static-1.4628",
  "ui-shepherd-react": "static-3.10005",
  "ai-settings-ui-library": "static-1.7640",
  "hub-http-janus": "static-1.809",
  "hubspotter-http": "static-1.4533",
  "immutable-less": "static-1.4513",
  "marketplace-ui-client-types": "static-1.16525",
  "nav-meta": "static-1.29098",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10101",
  "ui-addon-upgrades": "static-9.17744",
  "inbound-db-properties-service-client": "static-1.3726",
  "property-management-common": "static-1.4881",
  "ui-addon-iframeable": "static-1.8906",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.499",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.484",
  "quartz-head": "static-1.474",
  "quartz-test": "static-1.484",
  "quartz-tracking": "static-1.188",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.3014",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20576",
  "ContentUtils": "static-1.67804",
  "sassPrefix": "static-1.153",
  "avatar-components": "static-1.2351",
  "customer-data-filters-ui": "static-1.39116",
  "customer-data-objects-ui-components": "static-1.12871",
  "customer-data-reference-ui-components": "static-1.13007",
  "embedded-academy-lib": "static-1.13764",
  "ExportDialog": "static-6.10246",
  "highlight.js": "static-1.75",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40811",
  "reporting-snowflake": "static-1.55389",
  "reporting-ui-components": "static-2.64042",
  "reporting-visualizations": "static-1.58847",
  "ui-addon-teams": "static-1.21324",
  "magpie-lib": "static-1.5453",
  "magpie-types": "static-1.4913",
  "simple-logging-lib": "static-1.2909",
  "navigation-components": "static-1.17461",
  "ai-studio-lib": "static-1.11161",
  "app-governance-lib": "static-1.1062",
  "developer-experience-shared-components": "static-1.10359",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7850",
  "ui-product-approvals": "static-1.27634",
  "ui-tool-access": "static-1.10003",
  "usage-based-billing-components-lib": "static-1.8174",
  "usage-tracker-anonymous": "static-1.5611",
  "usage-tracker-public": "static-1.7005",
  "amplitude-session-replay-browser": "static-1.56",
  "inbound-db-meta-service-client": "static-1.3475",
  "persist-promise": "static-1.3567",
  "reference-resolvers": "static-1.8022",
  "ui-extensibility-client-types": "static-1.3800",
  "hubspot-apollo-cache": "static-1.197",
  "universal-page-editor-lib": "static-1.2860",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2344",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4929",
  "purchase-motions-components": "static-1.5571",
  "salesImages": "static-1.522",
  "batch-promise": "static-1.1410",
  "crm-component-utils": "static-1.38626",
  "crm-properties-common-lib": "static-1.5732",
  "customer-data-properties": "static-1.50970",
  "framework-data-schema-resolvers": "static-1.6732",
  "property-value-citations": "static-1.1584",
  "reference-resolvers-lite": "static-1.7943",
  "navigation-messaging": "static-1.6788",
  "hubspotter-http-shared-msw-handlers": "static-1.9618",
  "cms-field-types": "static-1.4668",
  "content-icons-ui": "static-1.2178",
  "conversations-skeleton-state": "static-1.7107",
  "crm-message-bus": "static-1.42545",
  "customer-data-filters-ui-msw-helpers": "static-1.21551",
  "customer-data-ui-utilities": "static-1.9683",
  "FormUrlGenerator": "static-2.4580",
  "framework-builder-read-service-client": "static-1.3888",
  "framework-data-schema-quick-fetch": "static-1.6637",
  "multi-account-reference-resolvers": "static-1.835",
  "onboarding-tours": "static-1.16345",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13229",
  "academy-common-lib": "static-1.13224",
  "content-assistance-lib": "static-1.7531",
  "dashboard-lib": "static-1.80867",
  "file-manager-components": "static-1.23088",
  "getting-started-shared-tasks": "static-1.18047",
  "hubspot-prosemirror": "static-1.17769",
  "hubspot-prosemirror-plugins": "static-1.17761",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19575",
  "share-with-third-party-component-lib": "static-1.8552",
  "ui-addon-draggable": "static-3.4627",
  "ui-asset-management-lib": "static-1.10792",
  "ui-business-units-lib": "static-1.8891",
  "user-context": "static-1.4959",
  "growth-payments-core": "static-1.24895",
  "reporting-plugins": "static-1.10052",
  "reporting-reports": "static-1.66449",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.584",
  "codemirror": "static-5.91",
  "feedback-loader": "static-1.28986",
  "react-codemirror": "static-1.10485",
  "framework-listing-lib": "static-2-rr-react-compiler.25",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30250",
  "apps-service-types": "static-1.3736",
  "oauth-service-types": "static-1.4106",
  "onboarding-scopes": "static-1.6322",
  "onboarding-tours-client": "static-1.4559",
  "platform-infra-nav-components": "static-1.7547",
  "subscription-experience-data-types": "static-1.14661",
  "crm-record-cards-service-types": "static-1.3497",
  "location-customization-utils-lib": "static-1.8751",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4358",
  "nav-client-types": "static-1.2216",
  "purchase-motions-api": "static-1.5574",
  "signup-constants": "static-1.18518",
  "signup-ui-url-generator": "static-2.7893",
  "trials-service-types": "static-1.3759",
  "card-properties-lib": "static-1.43694",
  "commerce-subscription-lib": "static-1.36629",
  "crm-actions": "static-1.6167",
  "crm-cards-sdk": "static-1.43097",
  "customer-data-properties-shared-msw-handlers": "static-1.8947",
  "customer-data-tracking": "static-1.6741",
  "hs-entities": "static-1.545",
  "pulse": "static-1.382",
  "calling-global-api": "static-1.63910",
  "calling-internal-common": "static-1.31158",
  "calling-lifecycle-internal": "static-1.65292",
  "calling-lifecycle-messages": "static-1.57586",
  "commerce-products-lib": "static-1.9013",
  "conditional-properties-service-client": "static-1.3678",
  "crm-links": "static-1.6127",
  "external-options-client-types": "static-1.4039",
  "google-libphonenumber": "static-1.34",
  "inbounddb-objects-service-types": "static-1.4103",
  "meetings-icalendar-utils-lib": "static-1.491",
  "multi-currency-client-types": "static-1.3570",
  "object-builder-ui-client": "static-1.48191",
  "pipeline-validation-client-types": "static-1.3844",
  "smart-property-lib": "static-1.6165",
  "tiered-pricing": "static-1.921",
  "ui-addon-form-validation": "static-1.10852",
  "crm-pipelines-api-client-types": "static-1.4020",
  "customer-data-associations": "static-1.7181",
  "customer-data-views-management": "static-1.25109",
  "framework-data-table": "static-2.11560",
  "marketing-platform-lib": "static-1.6703",
  "nudge-client-utils": "static-1.2274",
  "nudge-custom-ui-functions": "static-1.780",
  "react-dnd-compat": "static-1.4479",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5218",
  "growth-onboarding-confetti": "static-1.2931",
  "growth-onboarding-next-action-utils": "static-1.1453",
  "onboarding-tours-utils": "static-1.411",
  "ui-shepherd-tracker": "static-1.7386",
  "academy-service-client": "static-1.3539",
  "final-form": "static-1.66",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28101",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8242",
  "video-components-external": "static-1.10762",
  "video-data-lib": "static-1.34420",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8417",
  "payment-link-components": "static-1.23095",
  "ui-addon-emoji-picker": "static-1.9746",
  "EmailSignatureEditor": "static-1.24014",
  "viral-links-lib": "static-1.6897",
  "data-token-picker": "static-1.16147",
  "FileManagerLib": "static-1.38728",
  "react-flip-move": "static-1.66",
  "timezone-utils": "static-2.5103",
  "getting-started-shared-tasks-store": "static-1.17165",
  "campaign-roi-lib": "static-1.8458",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "app-users-service-client": "static-1.5399",
  "app-users-service-types": "static-1.4807",
  "mini-checkout-client": "static-1.26467",
  "onboarding-utils": "static-1.5211",
  "permissions-shared-i18n-strings-fe": "static-1.1975",
  "ui-coaching-tips-shared-config": "static-1.28086",
  "edison-service-client-types": "static-1.251",
  "eligibility-engine-service-types": "static-1.3040",
  "crm_data": "static-4.91442",
  "customer-data-sidebar": "static-2.45575",
  "enrichment-properties-lib": "static-1.15283",
  "commerce-billing-lib": "static-1.18655",
  "commerce-shared-components-lib": "static-1.18112",
  "commerce-tools-ui-lib": "static-1.9946",
  "crm-fe-perf": "static-1.22763",
  "directed-graph": "static-1.798",
  "event-emitter": "static-1.806",
  "fast-json-patch": "static-1.59",
  "calling-error-reporting": "static-1.31164",
  "shared-worker-versioning": "static-1.10898",
  "calling-usage-tracker": "static-1.6400",
  "voice-sms-access-library": "static-1.419",
  "commerce-permissions": "static-1.622",
  "products-iframe-lib": "static-1.7493",
  "products-ui-components-shared-msw-handlers": "static-1.10002",
  "breeze-intelligence-kit": "static-1.5405",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9703",
  "policy-lib": "static-1.6637",
  "react-tinymce": "static-1.54790",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9766",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53916",
  "tinymce-plugins": "static-1.57030",
  "tinymce-themes": "static-1.55886",
  "crm-export-dialog": "static-1.6151",
  "crm-index-associations-lib": "static-1.6294",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1476",
  "tanstack-virtual": "static-1.26",
  "nudge-custom-function-registry": "static-1.2031",
  "nudge-renderer-utils": "static-1.2350",
  "whisper-core-api": "static-1.6157",
  "InboxConnectUtils": "static-4.14378",
  "growth-onboarding-next-action-components": "static-1.1481",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6440",
  "content-media-composition-data-lib": "static-1.11690",
  "content-media-compositions": "static-2.15697",
  "media-bridge-lib": "static-1.18669",
  "commerce-tours-lib": "static-1.5811",
  "growth-onboarding-reliability": "static-1.4945",
  "sales-checkout-service-client": "static-1.3527",
  "draft-convert": "static-2.69",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.74",
  "draft-plugins": "static-2.21413",
  "sales-email-signature-service-client": "static-1.3702",
  "audio-components": "static-1.5695",
  "FileManagerCore": "static-1.38587",
  "FileManagerImages": "static-1.36239",
  "video-components": "static-1.12765",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5205",
  "settings-content-modals": "static-1.45630",
  "crm_universal": "static-1.21748",
  "customer-data-email": "static-1.17774",
  "card-payment-highlight-lib": "static-1.36682",
  "card-subscription-highlight-lib": "static-1.39052",
  "commerce-contract-lib": "static-1.11413",
  "customer-data-content": "static-1.26986",
  "invoices-highlight-card-lib": "static-1.54218",
  "orders-highlight-card-lib": "static-1.21023",
  "products-highlight-card-lib": "static-1.17297",
  "project-storage": "static-1.4592",
  "quotes-highlight-card-lib": "static-1.71392",
  "crm-source-interpretation-lib": "static-1.5190",
  "utility-belt": "static-1.2399",
  "payments-enrollment-embed-lib": "static-1.22178",
  "customer-data-rte": "static-1.32590",
  "cv-backend-services": "static-1.1521",
  "growth-onboarding-empty-states": "static-1.5451",
  "payments-post-enroll-local-storage-lib": "static-1.4973",
  "qrcode-generator": "static-1.65",
  "quotes-client-types": "static-1.37482",
  "calling-orchestration-schema": "static-1.35196",
  "sales-views-client-types": "static-1.4135",
  "hub-http-contrib": "static-1.2902",
  "interframe": "static-3.4621",
  "tinymce-data": "static-1.40001",
  "ui-addon-sales-email": "static-1.5072",
  "layout-dnd-components": "static-1.12156",
  "layout-dnd-utils": "static-1.11131",
  "ui-brand-identity-lib": "static-1.14304",
  "NamespacedHubStyle": "static-2.8950",
  "deal-intel-utils": "static-1.1480",
  "hls.js": "static-1.35",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4390",
  "video-embed": "static-1.35254",
  "social-insights-client-types": "static-1.21548",
  "checkout-sdk": "static-3.23310",
  "checkout-service-types": "static-1.3715",
  "company-details-components": "static-1.6043",
  "payment-method-components": "static-1.6750",
  "pricing-pages-ui-components": "static-1.12935",
  "quote-checkout-service-types": "static-1.3345",
  "upgrade-catalog-service-types": "static-1.3385",
  "access-control-lib": "static-1.10297",
  "EmailComponents": "static-1.54306",
  "EmailData": "static-1.52983",
  "redux-less": "static-2.9345",
  "sequences-lib": "static-1.7786",
  "ui-gdpr-components": "static-1.10207",
  "products-ui-components": "static-1.39532",
  "quotes-ui-lib": "static-1.80113",
  "SalesContentIndexUI": "static-3.8994",
  "accounting-integrations-ui-components": "static-1.6824",
  "invoices-ui-lib": "static-1.54234",
  "commerce-products-api": "static-1.2046",
  "SafeStorage": "static-1.4261",
  "invoices-iframe-lib": "static-1.56292",
  "quotes-modal-lib": "static-1.102070",
  "stripe-embedded-components": "static-1.7243",
  "draft-content-plugins": "static-1.27858",
  "ContentData": "static-1.67879",
  "layout-data-lib": "static-1.9456",
  "outpost": "static-1.4059",
  "hub-http-rxjs": "static-1.775",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3788",
  "billing-payments-client-types": "static-1.3848",
  "account-and-billing-fintech-outages": "static-3.18315",
  "pricing-pages-api": "static-1.12800",
  "ContentComponents": "static-2.70760",
  "marketing-contacts-lib": "static-1.9318",
  "marketing-email-service-types": "static-1.1808",
  "messaging-editing-lib": "static-1.45794",
  "messaging-usage-based-billing-components-lib": "static-1.656",
  "automation-ui-source-apps": "static-1.18394",
  "automation-ui-types": "static-1.19312",
  "messaging-types-lib": "static-1.45531",
  "onboarding-settings-client": "static-1.4364",
  "sequences-client-types-lib": "static-1.7643",
  "commerce-tax-lib": "static-1.377",
  "property-description-translator": "static-1.3715",
  "FireAlarmUi": "static-1.4388",
  "sales-templates-service-types-lib": "static-1.4047",
  "commerce-analytics-service-client": "static-1.3515",
  "totals-ui-components": "static-1.23147",
  "stripe-connect-js": "static-1.65",
  "advanced-menus-core": "static-1.14901",
  "advanced-menus-lib": "static-1.11869",
  "ui-memberships-settings-lib": "static-1.33608",
  "demographics-service-types": "static-1.1508",
  "automation-ui-ubb": "static-1.5228",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7199",
  "data-token-views": "static-1.16128",
  "forms-utils-lib": "static-1.12285",
  "payments-embed-points-lib": "static-1.12718",
  "simple-menus-core": "static-1.14900",
  "simple-menus-lib": "static-1.16417",
  "ui-addon-draggable-compat": "static-2.4113",
  "videoconference-integration-components": "static-1.6612",
  "automation-applications-service-types": "static-1.3392",
  "automation-platform-service-types": "static-1.2543",
  "ContentEditorUI": "static-2.76703",
  "short-messages-app-service-client": "static-1.3864",
  "web-interactives-components": "static-1.13504",
  "web-interactives-data": "static-1.13505",
  "messaging-shared-utils-lib": "static-1.105",
  "messaging-user-info-utils-lib": "static-1.275",
  "email-portal-health-service-types": "static-1.835",
  "commerce-totals-service-types": "static-1.3696",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21248",
  "automation-ui-usage-tracking": "static-1.20711",
  "data-studio-ubb": "static-1.2273",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26581",
  "collaboration-sidebar": "static-1.57291",
  "content-management-data-lib": "static-1.5185",
  "copilot-plugins": "static-1.10660",
  "cta-picker": "static-1.35991",
  "customer-agent-discovery-components-lib": "static-1.2607",
  "editor-components": "static-1.13018",
  "editor-iframe-lib": "static-1.8199",
  "error-messaging-js": "static-1.5049",
  "FormsCommonComponents": "static-1.85437",
  "pictos": "static-7.181",
  "react-transition-group": "static-2.61",
  "redux-request-state": "static-1.10505",
  "SharedLegalStrings": "static-1.1611",
  "smart-content-core": "static-1.42012",
  "smart-content-lib": "static-1.42665",
  "social-composer-lib": "static-1.58374",
  "structured-content-lib": "static-1.24772",
  "theme-previewer-lib": "static-1.52841",
  "tinymce-copilot": "static-1.15984",
  "xray-recommendation-lib": "static-1.7672",
  "automation-ui-routing": "static-1.20669",
  "sql-reporting-client-types": "static-1.5525",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.41800",
  "campaigns-utils-lib": "static-1.3014",
  "reporting-enablement": "static-1.22294",
  "chatspot-widget-iframe": "static-1.20568",
  "collaboration-sidebar-common": "static-1.2088",
  "forms-ai-lib": "static-1.4091",
  "codemirror-dlb": "static-1.58262",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6286",
  "report-customization-components": "static-1.12684",
  "data-quality-ui-library": "static-1.12469",
  "html-to-image": "static-1.50",
  "reporting-insights-lib": "static-1.1244"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11739",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "dashboard-client-types": "/dashboard-client-types/static-1.278",
  "data-fetching-client": "/data-fetching-client/static-1.9536",
  "foundations-components": "/foundations-components/static-1.7635",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.660",
  "foundations-theming": "/foundations-theming/static-1.4270",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.78",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-test-utils": "/hs-test-utils/static-1.7866",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9620",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11302",
  "I18n": "/I18n/static-7.1589",
  "jasmine-runner": "/jasmine-runner/static-1.6329",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11799",
  "quartz": "/quartz/static-1.6809",
  "react-dlb": "/react-dlb/static-1.74",
  "react-rhumb": "/react-rhumb/static-1.16509",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2722",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8704",
  "settings-ui-lib": "/settings-ui-lib/static-1.12382",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6852",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11003",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9404",
  "unified-auth": "/unified-auth/static-1.295",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.576",
  "usage-tracker": "/usage-tracker/static-1.7194",
  "usage-tracker-core": "/usage-tracker-core/static-1.7044",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7939",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6076",
  "integrations-lib": "/integrations-lib/static-1.15613",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19118",
  "property-management-iframe": "/property-management-iframe/static-1.12594",
  "quartz-config": "/quartz-config/static-1.587",
  "quartz-core": "/quartz-core/static-1.6028",
  "quartz-routing": "/quartz-routing/static-1.239",
  "quick-fetch": "/quick-fetch/static-1.3793",
  "react": "/react/static-7.182",
  "rpc-client-utils": "/rpc-client-utils/static-1.4501",
  "ts-schema": "/ts-schema/static-1.3960",
  "ui-universal-auth": "/ui-universal-auth/static-1.8781",
  "UIComponents": "/UIComponents/static-3.8249",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.416",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3285",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3086",
  "quartz-webpack": "/quartz-webpack/static-1.3033",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3904",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-assets": "/foundations-assets/static-1.4700",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1986",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9285",
  "react-aria": "/react-aria/static-1.62",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5230",
  "react-virtualized": "/react-virtualized/static-2.95",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1369",
  "ui-fonts": "/ui-fonts/static-1.564",
  "ui-images": "/ui-images/static-2.1114",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2753",
  "foundations-theming-base": "/foundations-theming-base/static-1.3255",
  "stylex": "/stylex/static-1.28",
  "HeadJS": "/HeadJS/static-2.724",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2977",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4185",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8529",
  "ai-rendering-library": "/ai-rendering-library/static-1.9491",
  "chirp-fetch": "/chirp-fetch/static-1.1742",
  "connections-embed-lib": "/connections-embed-lib/static-1.719",
  "copilot-toolkit": "/copilot-toolkit/static-1.10687",
  "laboratory-lib": "/laboratory-lib/static-3.7018",
  "marketplace-embed": "/marketplace-embed/static-1.21632",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9014",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19074",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13289",
  "sanitize-text": "/sanitize-text/static-1.8004",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8555",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5608",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4880",
  "wootric-nps": "/wootric-nps/static-1.6841",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4510",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4013",
  "highcharts": "/highcharts/static-8.100",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2403",
  "reporting-data": "/reporting-data/static-1.66771",
  "cssUtils": "/cssUtils/static-1.754",
  "flux-actions": "/flux-actions/static-1.317",
  "HubStyle": "/HubStyle/static-2.11610",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10070",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10233",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7184",
  "icons": "/icons/static-2.631",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17651",
  "storybook-react": "/storybook-react/static-1.29",
  "trellis-story-utils": "/trellis-story-utils/static-1.4379",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5118",
  "quartz-i18n": "/quartz-i18n/static-1.484",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3589",
  "customer-data-objects": "/customer-data-objects/static-1.7511",
  "property-translator": "/property-translator/static-1.5269",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7783",
  "hs-promise-utils": "/hs-promise-utils/static-1.5452",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4738",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13028",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5449",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7646",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4333",
  "superstore": "/superstore/static-1.4628",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10005",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7640",
  "hub-http-janus": "/hub-http-janus/static-1.809",
  "hubspotter-http": "/hubspotter-http/static-1.4533",
  "immutable-less": "/immutable-less/static-1.4513",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16525",
  "nav-meta": "/nav-meta/static-1.29098",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10101",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17744",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3726",
  "property-management-common": "/property-management-common/static-1.4881",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8906",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.499",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.484",
  "quartz-head": "/quartz-head/static-1.474",
  "quartz-test": "/quartz-test/static-1.484",
  "quartz-tracking": "/quartz-tracking/static-1.188",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.3014",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20576",
  "ContentUtils": "/ContentUtils/static-1.67804",
  "sassPrefix": "/sassPrefix/static-1.153",
  "avatar-components": "/avatar-components/static-1.2351",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39116",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12871",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13007",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13764",
  "ExportDialog": "/ExportDialog/static-6.10246",
  "highlight.js": "/highlight.js/static-1.75",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40811",
  "reporting-snowflake": "/reporting-snowflake/static-1.55389",
  "reporting-ui-components": "/reporting-ui-components/static-2.64042",
  "reporting-visualizations": "/reporting-visualizations/static-1.58847",
  "ui-addon-teams": "/ui-addon-teams/static-1.21324",
  "magpie-lib": "/magpie-lib/static-1.5453",
  "magpie-types": "/magpie-types/static-1.4913",
  "simple-logging-lib": "/simple-logging-lib/static-1.2909",
  "navigation-components": "/navigation-components/static-1.17461",
  "ai-studio-lib": "/ai-studio-lib/static-1.11161",
  "app-governance-lib": "/app-governance-lib/static-1.1062",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10359",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7850",
  "ui-product-approvals": "/ui-product-approvals/static-1.27634",
  "ui-tool-access": "/ui-tool-access/static-1.10003",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8174",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5611",
  "usage-tracker-public": "/usage-tracker-public/static-1.7005",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3475",
  "persist-promise": "/persist-promise/static-1.3567",
  "reference-resolvers": "/reference-resolvers/static-1.8022",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3800",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.197",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2860",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2344",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4929",
  "purchase-motions-components": "/purchase-motions-components/static-1.5571",
  "salesImages": "/salesImages/static-1.522",
  "batch-promise": "/batch-promise/static-1.1410",
  "crm-component-utils": "/crm-component-utils/static-1.38626",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5732",
  "customer-data-properties": "/customer-data-properties/static-1.50970",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6732",
  "property-value-citations": "/property-value-citations/static-1.1584",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7943",
  "navigation-messaging": "/navigation-messaging/static-1.6788",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9618",
  "cms-field-types": "/cms-field-types/static-1.4668",
  "content-icons-ui": "/content-icons-ui/static-1.2178",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7107",
  "crm-message-bus": "/crm-message-bus/static-1.42545",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21551",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9683",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4580",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3888",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6637",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.835",
  "onboarding-tours": "/onboarding-tours/static-1.16345",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13229",
  "academy-common-lib": "/academy-common-lib/static-1.13224",
  "content-assistance-lib": "/content-assistance-lib/static-1.7531",
  "dashboard-lib": "/dashboard-lib/static-1.80867",
  "file-manager-components": "/file-manager-components/static-1.23088",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18047",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17769",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17761",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19575",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8552",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4627",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10792",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8891",
  "user-context": "/user-context/static-1.4959",
  "growth-payments-core": "/growth-payments-core/static-1.24895",
  "reporting-plugins": "/reporting-plugins/static-1.10052",
  "reporting-reports": "/reporting-reports/static-1.66449",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.584",
  "codemirror": "/codemirror/static-5.91",
  "feedback-loader": "/feedback-loader/static-1.28986",
  "react-codemirror": "/react-codemirror/static-1.10485",
  "framework-listing-lib": "/framework-listing-lib/static-2-rr-react-compiler.25",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30250",
  "apps-service-types": "/apps-service-types/static-1.3736",
  "oauth-service-types": "/oauth-service-types/static-1.4106",
  "onboarding-scopes": "/onboarding-scopes/static-1.6322",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4559",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7547",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14661",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3497",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8751",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4358",
  "nav-client-types": "/nav-client-types/static-1.2216",
  "purchase-motions-api": "/purchase-motions-api/static-1.5574",
  "signup-constants": "/signup-constants/static-1.18518",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7893",
  "trials-service-types": "/trials-service-types/static-1.3759",
  "card-properties-lib": "/card-properties-lib/static-1.43694",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36629",
  "crm-actions": "/crm-actions/static-1.6167",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43097",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8947",
  "customer-data-tracking": "/customer-data-tracking/static-1.6741",
  "hs-entities": "/hs-entities/static-1.545",
  "pulse": "/pulse/static-1.382",
  "calling-global-api": "/calling-global-api/static-1.63910",
  "calling-internal-common": "/calling-internal-common/static-1.31158",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65292",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57586",
  "commerce-products-lib": "/commerce-products-lib/static-1.9013",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3678",
  "crm-links": "/crm-links/static-1.6127",
  "external-options-client-types": "/external-options-client-types/static-1.4039",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4103",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.491",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3570",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48191",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3844",
  "smart-property-lib": "/smart-property-lib/static-1.6165",
  "tiered-pricing": "/tiered-pricing/static-1.921",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10852",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4020",
  "customer-data-associations": "/customer-data-associations/static-1.7181",
  "customer-data-views-management": "/customer-data-views-management/static-1.25109",
  "framework-data-table": "/framework-data-table/static-2.11560",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6703",
  "nudge-client-utils": "/nudge-client-utils/static-1.2274",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.780",
  "react-dnd-compat": "/react-dnd-compat/static-1.4479",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5218",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2931",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1453",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.411",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7386",
  "academy-service-client": "/academy-service-client/static-1.3539",
  "final-form": "/final-form/static-1.66",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28101",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8242",
  "video-components-external": "/video-components-external/static-1.10762",
  "video-data-lib": "/video-data-lib/static-1.34420",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8417",
  "payment-link-components": "/payment-link-components/static-1.23095",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9746",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24014",
  "viral-links-lib": "/viral-links-lib/static-1.6897",
  "data-token-picker": "/data-token-picker/static-1.16147",
  "FileManagerLib": "/FileManagerLib/static-1.38728",
  "react-flip-move": "/react-flip-move/static-1.66",
  "timezone-utils": "/timezone-utils/static-2.5103",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17165",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8458",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "app-users-service-client": "/app-users-service-client/static-1.5399",
  "app-users-service-types": "/app-users-service-types/static-1.4807",
  "mini-checkout-client": "/mini-checkout-client/static-1.26467",
  "onboarding-utils": "/onboarding-utils/static-1.5211",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.1975",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28086",
  "edison-service-client-types": "/edison-service-client-types/static-1.251",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3040",
  "crm_data": "/crm_data/static-4.91442",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45575",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15283",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18655",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18112",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9946",
  "crm-fe-perf": "/crm-fe-perf/static-1.22763",
  "directed-graph": "/directed-graph/static-1.798",
  "event-emitter": "/event-emitter/static-1.806",
  "fast-json-patch": "/fast-json-patch/static-1.59",
  "calling-error-reporting": "/calling-error-reporting/static-1.31164",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10898",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6400",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.419",
  "commerce-permissions": "/commerce-permissions/static-1.622",
  "products-iframe-lib": "/products-iframe-lib/static-1.7493",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10002",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5405",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9703",
  "policy-lib": "/policy-lib/static-1.6637",
  "react-tinymce": "/react-tinymce/static-1.54790",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9766",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53916",
  "tinymce-plugins": "/tinymce-plugins/static-1.57030",
  "tinymce-themes": "/tinymce-themes/static-1.55886",
  "crm-export-dialog": "/crm-export-dialog/static-1.6151",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6294",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1476",
  "tanstack-virtual": "/tanstack-virtual/static-1.26",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2031",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2350",
  "whisper-core-api": "/whisper-core-api/static-1.6157",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14378",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1481",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6440",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11690",
  "content-media-compositions": "/content-media-compositions/static-2.15697",
  "media-bridge-lib": "/media-bridge-lib/static-1.18669",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5811",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4945",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3527",
  "draft-convert": "/draft-convert/static-2.69",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.74",
  "draft-plugins": "/draft-plugins/static-2.21413",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3702",
  "audio-components": "/audio-components/static-1.5695",
  "FileManagerCore": "/FileManagerCore/static-1.38587",
  "FileManagerImages": "/FileManagerImages/static-1.36239",
  "video-components": "/video-components/static-1.12765",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5205",
  "settings-content-modals": "/settings-content-modals/static-1.45630",
  "crm_universal": "/crm_universal/static-1.21748",
  "customer-data-email": "/customer-data-email/static-1.17774",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36682",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39052",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11413",
  "customer-data-content": "/customer-data-content/static-1.26986",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54218",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21023",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17297",
  "project-storage": "/project-storage/static-1.4592",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71392",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5190",
  "utility-belt": "/utility-belt/static-1.2399",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22178",
  "customer-data-rte": "/customer-data-rte/static-1.32590",
  "cv-backend-services": "/cv-backend-services/static-1.1521",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5451",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4973",
  "qrcode-generator": "/qrcode-generator/static-1.65",
  "quotes-client-types": "/quotes-client-types/static-1.37482",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35196",
  "sales-views-client-types": "/sales-views-client-types/static-1.4135",
  "hub-http-contrib": "/hub-http-contrib/static-1.2902",
  "interframe": "/interframe/static-3.4621",
  "tinymce-data": "/tinymce-data/static-1.40001",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5072",
  "layout-dnd-components": "/layout-dnd-components/static-1.12156",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11131",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14304",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8950",
  "deal-intel-utils": "/deal-intel-utils/static-1.1480",
  "hls.js": "/hls.js/static-1.35",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4390",
  "video-embed": "/video-embed/static-1.35254",
  "social-insights-client-types": "/social-insights-client-types/static-1.21548",
  "checkout-sdk": "/checkout-sdk/static-3.23310",
  "checkout-service-types": "/checkout-service-types/static-1.3715",
  "company-details-components": "/company-details-components/static-1.6043",
  "payment-method-components": "/payment-method-components/static-1.6750",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.12935",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3345",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3385",
  "access-control-lib": "/access-control-lib/static-1.10297",
  "EmailComponents": "/EmailComponents/static-1.54306",
  "EmailData": "/EmailData/static-1.52983",
  "redux-less": "/redux-less/static-2.9345",
  "sequences-lib": "/sequences-lib/static-1.7786",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10207",
  "products-ui-components": "/products-ui-components/static-1.39532",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80113",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8994",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6824",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54234",
  "commerce-products-api": "/commerce-products-api/static-1.2046",
  "SafeStorage": "/SafeStorage/static-1.4261",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56292",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102070",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7243",
  "draft-content-plugins": "/draft-content-plugins/static-1.27858",
  "ContentData": "/ContentData/static-1.67879",
  "layout-data-lib": "/layout-data-lib/static-1.9456",
  "outpost": "/outpost/static-1.4059",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.775",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3788",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3848",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18315",
  "pricing-pages-api": "/pricing-pages-api/static-1.12800",
  "ContentComponents": "/ContentComponents/static-2.70760",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9318",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1808",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.45794",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.656",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18394",
  "automation-ui-types": "/automation-ui-types/static-1.19312",
  "messaging-types-lib": "/messaging-types-lib/static-1.45531",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4364",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7643",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.377",
  "property-description-translator": "/property-description-translator/static-1.3715",
  "FireAlarmUi": "/FireAlarmUi/static-1.4388",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4047",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3515",
  "totals-ui-components": "/totals-ui-components/static-1.23147",
  "stripe-connect-js": "/stripe-connect-js/static-1.65",
  "advanced-menus-core": "/advanced-menus-core/static-1.14901",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11869",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33608",
  "demographics-service-types": "/demographics-service-types/static-1.1508",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5228",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7199",
  "data-token-views": "/data-token-views/static-1.16128",
  "forms-utils-lib": "/forms-utils-lib/static-1.12285",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12718",
  "simple-menus-core": "/simple-menus-core/static-1.14900",
  "simple-menus-lib": "/simple-menus-lib/static-1.16417",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4113",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6612",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3392",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2543",
  "ContentEditorUI": "/ContentEditorUI/static-2.76703",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3864",
  "web-interactives-components": "/web-interactives-components/static-1.13504",
  "web-interactives-data": "/web-interactives-data/static-1.13505",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.105",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.275",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.835",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3696",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21248",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.20711",
  "data-studio-ubb": "/data-studio-ubb/static-1.2273",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26581",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57291",
  "content-management-data-lib": "/content-management-data-lib/static-1.5185",
  "copilot-plugins": "/copilot-plugins/static-1.10660",
  "cta-picker": "/cta-picker/static-1.35991",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2607",
  "editor-components": "/editor-components/static-1.13018",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8199",
  "error-messaging-js": "/error-messaging-js/static-1.5049",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85437",
  "pictos": "/pictos/static-7.181",
  "react-transition-group": "/react-transition-group/static-2.61",
  "redux-request-state": "/redux-request-state/static-1.10505",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1611",
  "smart-content-core": "/smart-content-core/static-1.42012",
  "smart-content-lib": "/smart-content-lib/static-1.42665",
  "social-composer-lib": "/social-composer-lib/static-1.58374",
  "structured-content-lib": "/structured-content-lib/static-1.24772",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.52841",
  "tinymce-copilot": "/tinymce-copilot/static-1.15984",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7672",
  "automation-ui-routing": "/automation-ui-routing/static-1.20669",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5525",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.41800",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3014",
  "reporting-enablement": "/reporting-enablement/static-1.22294",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20568",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2088",
  "forms-ai-lib": "/forms-ai-lib/static-1.4091",
  "codemirror-dlb": "/codemirror-dlb/static-1.58262",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6286",
  "report-customization-components": "/report-customization-components/static-1.12684",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12469",
  "html-to-image": "/html-to-image/static-1.50",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1244"
}
};
